<template>
	<contentBox v-if="!loadError" v-bind:loading="!recLoaded">
		<contentTitle v-if="rec" label="SEWER MAIN" close="home">
			<h2 class="text-white font-weight-light pb-2">{{title}}</h2>
		</contentTitle>
		<contentBody v-if="rec" v-bind:locked="!planActive">
			<contentActions v-if="rec">
				<button class="btn btn-outline-light btn-sm" v-bind:class="{active:shareShown === true}" v-on:click="share">
					<i class="material-icons md-18" title="center map on zoning">share</i> 
					Share
				</button>
				<button class="btn btn-outline-light btn-sm" v-on:click="zoomTo">
					<i class="material-icons md-18" title="center map on zoning">place</i> 
					Center
				</button>
			</contentActions>
			<share v-if="shareShown" v-bind:link="location" @close="share"></share>
			<div class="p-3">
				<div class="lock-block mb-3" v-if="!planActive">
					<div class="row mx-0 hover-dk" v-on:click="routeUnlock">
						<div class="col-2 text-center my-auto">
							<i class="material-icons text-light mr-3 md-36">lock</i>
						</div>
						<div class="py-3 col-10 pl-0 pr-3 py-3">
							<h5 class="mb-0 text-white">Purchase day pass to unlock</h5>
							<h5 class="mb-0 font-weight-light text-light">Get details on pipe dimensions, drawing references, and responsible parties</h5>
						</div>
					</div>
				</div>
				<div class="category-body">
					<div class="category">
						<div class="category-title">PIPE DETAILS</div>
						<div class="property-row">
							<label>Type</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.pipeType !== null">
									{{rec.pipeType}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>			
						</div>
						<div class="property-row">
							<label>Diameter</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.pipeDiameterInches !== null">
									{{rec.pipeDiameterInches}} in
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Functional Diameter</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.functionalDiameterInches !== null">
									{{rec.functionalDiameterInches}} in
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Length</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.lengthFeet !== null && rec.lengthFeet !== 0">
									{{rec.lengthFeet}} ft
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Material</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.material !== null">
									{{rec.material}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Lining Type</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.liningType !== null">
									{{rec.liningType}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Located in Easement</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.easement !== null">
									{{easement}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Installed on</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.installDate !== null">
									{{installedDate}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">RESPONSIBLE PARTIES</div>
						<div class="property-row">
							<label>Owner</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.owner !== null">
									{{rec.owner}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Maintainer</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.maintainer !== null">
									{{rec.maintainer}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">DRAWING</div>
						<div class="property-row">
							<label>Number</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.drawingNumber !== null">
									{{rec.drawingNumber}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Sheet</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.drawingSheet !== null">
									{{rec.drawingSheet}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Type</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.drawingType !== null">
									{{rec.drawingType}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">PRESSURE</div>
						<div class="property-row">
							<label>Class</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.pressureClass !== null">
									{{rec.pressureClass}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>PSI</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.pressurePsi !== null">
									{{rec.pressurePsi}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">SYPHON</div>
						<div class="property-row">
							<label>Is Syphon</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.syphon !== null">
									{{syphon}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Low Inverted Elevation</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.syphonLowInvertedElevationFeet !== null && rec.syphonLowInvertedElevationFeet !== 0">
									{{rec.syphonLowInvertedElevationFeet}} ft
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">UPSTREAM</div>
						<div class="property-row">
							<label>Inverted Elevation</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.upstreamInvertedElevationFeet !== null">
									{{rec.upstreamInvertedElevationFeet}} ft
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Facility</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.upstreamFacility !== null">
									{{rec.upstreamFacility}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">DOWNSTREAM</div>
						<div class="property-row">
							<label>Inverted Elevation</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.downstreamInvertedElevationFeet !== null">
									{{rec.downstreamInvertedElevationFeet}} ft
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Facility</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.downstreamFacility !== null">
									{{rec.downstreamFacility}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="category-title">FIELD BOOK</div>
						<div class="property-row">
							<label>Page</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.fieldBookPage !== null">
									{{rec.fieldBookPage}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Grid</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.fieldBookGrid !== null">
									{{rec.fieldBookGrid}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Upstream Page</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.upstreamFieldBookPageNum !== null">
									{{rec.upstreamFieldBookPageNum}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Upstream Map</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.upstreamFieldBookPageMap !== null">
									{{rec.upstreamFieldBookPageMap}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Downstream Page</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.downstreamFieldBookPageNum !== null">
									{{rec.downstreamFieldBookPageNum}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
						<div class="property-row">
							<label>Downstream Map</label>
							<div class="property-value-right property-locked">
								<span v-if="rec.downstreamFieldBookPageMap !== null">
									{{rec.downstreamFieldBookPageMap}}
								</span>
								<span v-else class="undef">
									-
								</span>
							</div>
						</div>
					</div>
					<div class="over-action d-flex" v-if="!planActive" v-on:click="routeUnlock">
						<div class="over-action-box align-self-center text-white hover-dk">
							<div class="text-center">
								<i class="material-icons text-light md-36">lock</i>
							</div>
							<div class="text-center">
								Unlock to view
							</div>
						</div>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>

</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import share from '../share/share';

export default {
	name:'sewer-main-full',
	props: {},
	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		share
	},
	computed:{
		token: function(){
			return this.$store.state.agent.token;
		},
		rec: function(){
			return this.$store.state.sewerMain.rec;
		},
		easement: function(){
			return this.rec.easement? 'Yes': 'No';
		},
		installedDate: function(){
			if (!this.rec.installDate){
				return ""
			}
			var d = new Date(this.rec.installDate);

			//	sniffing for invalid dates
			if (d.getUTCFullYear() == 1){
				return ""
			}

			//	format our datestring
			return (d.getUTCMonth()+1) +"/"+ d.getUTCDate() + "/" + d.getUTCFullYear();
		},
		syphon: function(){
			return this.rec.syphon? 'Yes': 'No';
		},
		title:function(){
			return this.rec.pipeDiameterInches+'" '+this.rec.pipeType;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		planActive:function(){
			return this.$store.state.plan.active;
		},
		location:function(){
			return window.location.href;
		},
		zoomToDone:function(){
			return this.$store.state.map.fitBoundsDone;
		}
	},
	created: function(){
		this.getRec();
		this.getPlanActive();
	},
	data: function(){
		return {
			recLoaded:false,
			shareShown:false,
			loadError:null
		}
	},
	destroyed: function(){
		this.$store.dispatch('SEWER_MAIN_HIGHLIGHT_CLEAR',{});
	},
	methods:{
		getRec: function(){
			this.recLoaded = false;
			this.loadError = null;
			
			this.$store.dispatch('SEWER_MAIN_GET', {
				id: this.$route.params.id
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		getPlanActive: function(){
			this.$store.dispatch('PLAN_ACTIVE_CHECK');			
		},
		routeClose:function(){
			this.$router.push({
				name:'home'
			});
		},
		routeUnlock:function(){
			this.$router.push({
				name:'unlock'
			});
		},
		highlight:function(){
			this.$store.dispatch('SEWER_MAIN_HIGHLIGHT',{});
		},
		zoomTo:function(){
			this.$store.dispatch('SEWER_MAIN_ZOOM_TO',{});
		},
		checkInside:function(){
			if (!this.rec.geom || !this.rec.geom.coordinates || this.rec.geom.coordinates.length < 1) return true;

			const coords = this.rec.geom.coordinates[0];
			let bbox = [coords[0][0],coords[0][1],coords[0][0],coords[0][1]];

			coords.map((c)=>{
				if (c[0] < bbox[0]) bbox[0] = c[0];
				else if (c[0] > bbox[2]) bbox[2] = c[0];
				if (c[1] < bbox[1]) bbox[1] = c[1];
				else if (c[1] > bbox[3]) bbox[3] = c[1];
			});

			const bounds = this.mapBounds;

			if (this.mapZoom <= 15) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.rec || !this.mapLoaded) return;
			this.ready();
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else this.highlight();
			this.updateTitleTag();
		},
		updateTitleTag:function(){
			document.title = 'Sewer main '+this.title+' - Scoutred Maps';
		},
		share:function(){
			if (this.shareShown){
				this.shareShown = false;
				return;
			}
			if (navigator.share){
				navigator.share({
				  title: 'Sewer main '+this.title+' - Scoutred Maps',
				  text: 'Sewer main data for '+this.title,
				  url: window.location.href,
				});
				return;
			}

			this.shareShown = true;
		}
	},
	watch: {
		$route:function(toRoute, fromRoute){
			if (fromRoute && toRoute.params.id !== fromRoute.params.id){ // route resource has changed
				this.getRec();
				this.getPlanActive();
			}
		},
		rec:function(rec){
			this.checkReady();
			if (rec) this.recLoaded = true;
		},
		mapLoaded:function(){
			this.checkReady();
		},
		zoomToDone:function(){
			this.highlight();
		}
	},
};

</script>


// WEBPACK FOOTER //
// src/components/sewer-main/sewer-main-full.vue